// extracted by mini-css-extract-plugin
export default {"select-group":"zVJU_PMSuBKAgbUQO1lN"};